import React from 'react';
import { conTipo, Tipo } from '../../../Models/Productos';
import { FilaTipo } from './Fila';
import ReactTooltip from 'react-tooltip';
import NuevoTipo from './Nuevo';
import CardBuscador from '../../../Utiles/Buscadores/Card';
import { Button, Col, InputGroup, Row } from 'react-bootstrap';
import { InputText } from '../../../Utiles/Inputs';
import { UTDContext } from '../../../Context/Producto/UTD';
class ListTipo extends CardBuscador {
    con = conTipo();
    mostrar = 6;
    placeholder = "BUSCAR TIPO DE PRODUCTO";
    estatus = [{ value: 0, label: 'CANCELADO' }, { value: 1, label: 'SIN FACTURA' }, { value: 2, label: 'FACTURADA' }];
    buscarEn = ["codigo", "descripcion"];
    Title() {
        return <h4 className='mr-auto'><i className="fa fa-search"></i> BUSCAR TIPO DE PRODUCTO</h4>
    }
    Avansado() {
        return <></>;
    }
    Buscador() {
        return <>
            <ReactTooltip />
            <Row className='d-flex' style={{ paddingBottom: '15px' }}>
                <Col md={9} className='mr-auto'>
                    <InputGroup>
                        <InputGroup.Prepend>
                            <InputGroup.Text>
                                BUSCAR
                            </InputGroup.Text>
                        </InputGroup.Prepend>
                        <InputText upper setData={this.setState} update='buscar' value={this.state.buscar} />
                        <InputGroup.Append>
                            <Button variant="primary"><i className="fa fa-search"></i> BUSCAR</Button>
                        </InputGroup.Append>
                    </InputGroup>
                </Col>
                {this.Actualizar()}
            </Row>
            <NuevoTipo update={this.set.bind(this)} />
        </>
    }
    Header() {
        const { Th } = this;
        return <tr className="info">
            <Th label='codigo' width='100px'>COD</Th>
            <Th label='descripcion' width='calc(100% - 270px)'>DESCRIPCION</Th>
            <Th width='130px'>INVENTARIO</Th>
            <Th width='100px'>ESTATUS</Th>
            <Th width='70px'>ACCIONES</Th>
        </tr>
    }
    Row(p: Tipo) {
        return <FilaTipo key={'tipo' + p.codigo} d={p} update={this.set.bind(this)} />
    }
    context: any = {};
    getItens() { return this.context.Tipos; }
    set() { this.context.actTipo(); }
    getEstado() { return this.context.estTipos; }

}
ListTipo.contextType = UTDContext;
export default ListTipo;
